import { useContext } from "react";
import Select, { components } from "react-select";

import { GrantsAndIncentivesContext } from "common/contexts";

import ButtonNew from "components/atoms/ButtonNew/index";
import { IoChevronDown } from "components/atoms/Icon/io5/IoChevronDown";

import styles from "../Index.module.scss";

const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    color: "#333",
    borderRadius: 10,
    padding: "16px 24px",
    lineHeight: "26px",
    borderWidth: "0.5px",
    borderColor: "#007EFF !important",
    boxShadow: "none",
    fontWeight: "500",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 10,
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    overflowX: "hidden",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isSelected ? "#007eff" : "#333",
    background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isSelected ? "600" : "normal",
    cursor: "pointer",
    margin: "2px 2px",
  }),
  placeholder: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    color: "#333",
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    lineHeight: "26px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  group: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    padding: "0px 0px 0px 20px",
  }),
  groupHeading: (provided) => ({
    ...provided,
    fontSize: "16px",
    color: "#007eff",
    position: "relative",
    left: "-16px",
    marginBottom: "0px",
  }),
};

function Step1({ data }) {
  const { setStep, dataStep1, setDataStep1 } = useContext(
    GrantsAndIncentivesContext
  );

  const { needs_based, industry, business_stage } = data;
  // Because need_base return from api is a list single object not  hierarchical object list
  // So have to custom this to hierarchical list
  const customNeedsBase = () => {
    const customData = [...needs_based];
    const childrenObjectArr = customData.filter((item) => item.parent_id); // Get item which have parent by parent_id in each item
    let options_list_filter = [];
    const options_list_can_select = [];

    // Custom data to react-select structure {option:abc, label:xyz}
    for (let index = 0; index < customData.length; index++) {
      const item = customData[index];
      // Filter children which belong to item children by item.value
      // Item.value also children_parent_id
      const options_list = childrenObjectArr.filter(
        (child) => child.parent_id == item.value
      );

      // Push children list for remove from main data when return hierarchical object list
      options_list_filter = [...options_list_filter, ...options_list];

      // Some parent can click and some parent can't
      // Push children options to item option if item is disabled. Item have is_disabled and option_list.length > 0.
      if (options_list.length > 0 && item.is_disabled === true) {
        item.options = options_list;
      } else if (options_list.length > 0 && item.is_disabled === false) {
        // Item is Parent and have children list but can select parent so push parent tu option_list_can_select
        options_list_can_select.push({
          label: item.label,
          options: options_list,
        });
      }
    }
    // Remove parent can select from main data
    for (let index = 0; index < options_list_can_select.length; index++) {
      const element = options_list_can_select[index];
      const index_of_option = customData.findIndex(
        (item) => item?.label?.localeCompare(element.label) === 0
      );

      customData.splice(index_of_option + 1, 0, { options: element.options });
    }

    return (
      // Remove children contain in parent from main data
      customData.filter(
        (item) =>
          options_list_filter.findIndex(
            (option) => option.value === item.value
          ) < 0
      ) || []
    );
  };
  const checkParentCanSelect = (el) => {
    return (
      el.is_disabled === false &&
      el.parent_id === null &&
      needs_based.filter((item) => item.parent_id === el.value).length > 0
    );
  };
  const CustomOption = (props) => {
    const { data, innerRef, innerProps, isSelected } = props;

    return checkParentCanSelect(data) ? (
      <div
        ref={innerRef}
        {...innerProps}
        className={`cursor-pointer px-4 py-2 font-medium  text-bbc-brand-500 hover:bg-bbc-brand-100 ${
          isSelected ? "bg-bbc-brand-100" : ""
        }`}
      >
        {data.label}
      </div>
    ) : (
      <components.Option {...props} />
    );
  };

  return (
    <>
      <div className={`${styles.step1} relative z-30`}>
        <div className="mb-8">
          <p className={`${styles.title}`}>
            What types of activities are you looking to getting support?
          </p>
          <Select
            defaultValue={dataStep1.needs_based_hold}
            options={[...customNeedsBase()]}
            isSearchable={true}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              IndicatorsContainer: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
              Option: CustomOption,
            }}
            onChange={(value) => {
              // If (checkParentCanSelect(value)) {
              //   SetDataStep1((prev) => ({
              //     ...prev,
              //     Needs_based: needs_based
              //       .filter((item) => item.parent_id === value.value)
              //       .map((item) => item.value),
              //   }));
              // } else {
              //   SetDataStep1((prev) => ({
              //     ...prev,
              //     Needs_based_hold: value,
              //     Needs_based: value.value,
              //   }));
              // }
              setDataStep1((prev) => ({
                ...prev,
                needs_based_hold: value,
                needs_based: value.value,
              }));
            }}
          />
        </div>
        <div className="mb-8">
          <p className={`${styles.title}`}>
            What industry does your company conduct business in?
          </p>
          <Select
            defaultValue={dataStep1.industry_hold}
            options={industry}
            isSearchable={true}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              IndicatorsContainer: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              setDataStep1((prev) => ({
                ...prev,
                industry_hold: value,
                industry: value.value,
              }));
            }}
          />
        </div>
        <div className="mb-8">
          <p className={`${styles.title}`}>
            How could you describe your business in terms of size?
          </p>
          <Select
            defaultValue={dataStep1.business_stage_hold}
            options={business_stage}
            isSearchable={false}
            // InputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              IndicatorsContainer: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              setDataStep1((prev) => ({
                ...prev,
                business_stage_hold: value,
                business_stage: value.value,
              }));
            }}
          />
        </div>
      </div>
      <div className="text-right">
        <ButtonNew
          disabled={dataStep1 && Object.keys(dataStep1).length < 5}
          variant={"ghost"}
          btnPadding={"px-0 py-0"}
          btnColor="bg-transparent"
          othersClass={styles.disabledBtn}
          onClick={() => {
            setStep((prev) => prev + 1);
          }}
        >
          Next
        </ButtonNew>
      </div>
    </>
  );
}

export default Step1;
